import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import Logo from "images/LivingSpaceLogoWhite-1.svg";

const styles = theme => ({
  uppercase: {
    textTransform: "uppercase"
  },
  bgImageWrapper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    minHeight: "400px",
    padding: "40px 0px",
    [theme.breakpoints.up("lg")]: {
      minHeight: "800px"
    }
  },
  body: {
    fontSize: "1rem",
    letterSpacing: "0.75px"
  },
  signature_image: {
    width: "200px"
  },
  logo: {
    width: "150px",
    [theme.breakpoints.up("lg")]: {
      width: "150px"
    }
  }
});

function FounderQuote(props) {
  const { data, classes } = props;
  return (
    <Container maxWidth={false}>
      <div className={classes.bgImageWrapper} style={{ position: "relative" }}>
        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)", // adjust opacity/color here
            zIndex: 1
          }}
        />

        {/* Background image */}
        <div
          style={{
            backgroundImage: `url(${data.image.url})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0
          }}
        />

        {/* Content */}
        <Grid container style={{ position: "relative", zIndex: 2 }}>
          <Grid item xs={1} />
          <Box
            component={Grid}
            item
            xs={12}
            md={4}
            display="flex"
            alignItems="center"
            flexDirection="column"
            p={4}
          >
            <Box mb={2}>
              <Logo className={classes.logo} />
            </Box>
            <Typography
              variant="h3"
              component="p"
              color="secondary"
              align="center"
            >
              {data.title[0].text}
            </Typography>
            <Box py={4}>
              <Typography
                component="p"
                variant="subtitle2"
                color="secondary"
                align="center"
                className={classes.body}
              >
                {data.text[0].text}
              </Typography>
            </Box>
            <Box mb={2}>
              <img
                src={data.signature_image.url}
                alt={data.signature_image.alt}
                className={classes.signature_image}
              />
            </Box>
            <Typography component="p" variant="h6" color="secondary">
              {data.author[0].text}
            </Typography>
            <Typography component="p" variant="button" color="secondary">
              {data.job_title[0].text}
            </Typography>
          </Box>
        </Grid>
      </div>
    </Container>
  );
}

FounderQuote.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired
};

export default withStyles(styles)(FounderQuote);
